import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useOptionalSiteSettings } from '../context/SiteSettingsContext';
var DEFAULT_FAVICON_URL = '/favicon.ico';
var DEFAULT_APPLE_TOUCH_ICON_URL = '/apple-touch-icon.png';
var SiteBrandingHead = function () {
    var _a, _b;
    var siteSettings = useOptionalSiteSettings();
    var customFaviconUrl = ((_b = (_a = siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.settings) === null || _a === void 0 ? void 0 : _a.branding) === null || _b === void 0 ? void 0 : _b.faviconUrl) || null;
    var faviconUrl = customFaviconUrl || DEFAULT_FAVICON_URL;
    var appleTouchIconUrl = customFaviconUrl || DEFAULT_APPLE_TOUCH_ICON_URL;
    return (_jsxs(Helmet, { children: [_jsx("link", { rel: "icon", href: faviconUrl }), _jsx("link", { rel: "shortcut icon", href: faviconUrl }), _jsx("link", { rel: "apple-touch-icon", href: appleTouchIconUrl })] }));
};
export default SiteBrandingHead;
